export interface ScrollEndOptions {
  panelSelector?: string;
  captureScroll?: boolean;
  observeCharacterData?: boolean;
}

/** Bind to the mounted host, including a panel that may arrive through lazy loading. */
export function observeScrollEnd(
  host: HTMLElement,
  onChange: (atEnd: boolean) => void,
  options: ScrollEndOptions = {},
) {
  const capture = options.captureScroll ?? false;
  const compute = () => {
    const panel = options.panelSelector
      ? host.querySelector<HTMLElement>(options.panelSelector)
      : host;
    if (!panel) return;
    onChange(panel.scrollHeight - panel.scrollTop - panel.clientHeight <= 24);
  };
  const observer = new MutationObserver(compute);
  observer.observe(host, {
    childList: true,
    subtree: true,
    characterData: options.observeCharacterData ?? false,
  });
  host.addEventListener("scroll", compute, capture ? true : { passive: true });
  window.addEventListener("resize", compute);
  const settle = window.setTimeout(compute, 400);
  compute();

  return () => {
    observer.disconnect();
    host.removeEventListener("scroll", compute, capture);
    window.removeEventListener("resize", compute);
    window.clearTimeout(settle);
  };
}